import * as React from "react";
import { gql, useMutation, ApolloError, MutationTuple } from "@apollo/client";
import {
  UpdateCommunityEntityMutationMutation,
  UpdateCommunityEntityMutationMutationVariables
} from "../../../../schemaTypes";

export const updateCommunityEntityMutation = gql`
mutation UpdateCommunityEntityMutation(
    $communityEntityId: String!,
    $input: UpdateCommunityEntityInput!
) {
    updateCommunityEntity(
        communityEntityId: $communityEntityId,
        input: $input
    ) {
        errors {
            path
            message
        }
        message
    }
  }
`;

interface Props {
    children: (data: {
        updateCommunityEntity: MutationTuple<
            UpdateCommunityEntityMutationMutation,
            UpdateCommunityEntityMutationMutationVariables
        >[0];
        loading: boolean;
        error?: ApolloError;
        data?: UpdateCommunityEntityMutationMutation;
        errors?: { path: string; message: string }[] | null;
        message?: string | null;
    }) => React.ReactElement | null;
}

export const UpdateCommunityEntity: React.FC<Props> = ({ children }) => {
    const [updateCommunityEntity, { loading, error, data }] = useMutation<
        UpdateCommunityEntityMutationMutation, 
        UpdateCommunityEntityMutationMutationVariables
    >(updateCommunityEntityMutation);

    const errorsRaw = data?.updateCommunityEntity?.errors ?? null;
    const errors = Array.isArray(errorsRaw)
        ? errorsRaw.filter((e): e is { path: string; message: string } => !!e)
        : errorsRaw;
    const message = data?.updateCommunityEntity?.message ?? null;

    return children({
        updateCommunityEntity,
        loading,
        error,
        data: data ?? undefined,
        errors,
        message
    });
};
